import { render, staticRenderFns } from "./WorkHeader.vue?vue&type=template&id=0c9c58ff&scoped=true&"
import script from "./WorkHeader.vue?vue&type=script&lang=js&"
export * from "./WorkHeader.vue?vue&type=script&lang=js&"
import style0 from "./WorkHeader.vue?vue&type=style&index=0&id=0c9c58ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9c58ff",
  null
  
)

export default component.exports